import { wagmiConfig, } from "@wagmiconfig";
import { getChainId, } from "wagmi/actions";
import { getTokenDefinition, } from "@bracket/chainography";
import type { Notification, } from "@bracket/ui";
import type { WEIString, } from "@bracket/types";
import {
  getExplorerLink,
  type TokenIdentifier,
} from "@bracket/chainography";

type NotificationKey = "BRKT:MINTED";

// biome-ignore lint/suspicious/noExplicitAny: will type the props later.
export const MQNotifications: Record<NotificationKey, (msg: any) => Omit<Notification, "id">>  = {
  "BRKT:MINTED": ({
    amount,
    amount_brkt,
    token,
    transaction_hash,
    wrapped,
  }:{
    amount: WEIString;
    amount_brkt: WEIString;
    token: TokenIdentifier;
    transaction_hash: string;
    wrapped?: boolean;
  }) => {
    const { label, decimals, } = getTokenDefinition(wrapped ? "WETH" : token);
    const inAmount = (Number(amount) / (10**decimals)).toFixed(5);
    const outAmount = (Number(amount_brkt) / (10**decimals)).toFixed(5);
    return {
      type: "success",
      title: "BRKT Minted",
      message: `You swapped ${inAmount} ${label} to buy ${outAmount} brktETH`,
      status: "success",
      primaryAction: {
        label: "View Transaction",
        onClick: () => {
          window.open(getExplorerLink(transaction_hash, getChainId(wagmiConfig)), "_blank");
        },
      },
    }
  }
}